export const STUDENT = '/students'
export const STUDENT_INFO = `${STUDENT}/info`
export const STUDENT_INFO_PUBLIC = '/:category/student-info'
export const STUDENT_TRANSCRIPT_PUBLIC = '/public/transcript/:token'
export const STUDENT_PROOF_STUDY_PUBLIC = '/public/proof-of-study/:token'
